import { render, staticRenderFns } from "./m-bulk-actions-ticket.vue?vue&type=template&id=f2efd22e&scoped=true"
import script from "./m-bulk-actions-ticket.vue?vue&type=script&lang=js"
export * from "./m-bulk-actions-ticket.vue?vue&type=script&lang=js"
import style0 from "./m-bulk-actions-ticket.vue?vue&type=style&index=0&id=f2efd22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2efd22e",
  null
  
)

export default component.exports